(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("library", [], factory);
	else if(typeof exports === 'object')
		exports["library"] = factory();
	else
		root["library"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"default\", function() { return Paginator; });\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n/**\n * Pagination logic handling.\n */\nvar Paginator =\n/*#__PURE__*/\nfunction () {\n  /**\n   * Creates a new Paginator instance.\n   * @param {Number}  [offset=50]\n   * @param {Array}  [data=[]]\n   */\n  function Paginator() {\n    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;\n    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];\n\n    _classCallCheck(this, Paginator);\n\n    this.atts = {\n      offset: offset,\n      data: data,\n      page: 1\n    };\n  }\n  /**\n   * Returns the paginator offset.\n   * @returns {Number}\n   */\n\n\n  _createClass(Paginator, [{\n    key: \"data\",\n\n    /**\n     * if called with parameter sets the paginator data,\n     * Retrieves the data from the current paginator page.\n     * @param {Array} [data = null]\n     * @returns {Array}\n     */\n    value: function data() {\n      var _data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;\n\n      if (_data) {\n        this.atts.data = _data;\n        this.page = 1;\n      }\n\n      return this.atts.data.slice(this.pageStart, this.pageEnd);\n    }\n    /**\n     * Get the current paginator page.\n     * @returns {Number}\n     */\n\n  }, {\n    key: \"inPageRange\",\n\n    /**\n     * Checks whether a page is valid.\n     * @param {Number} page\n     * @returns {boolean}\n     */\n    value: function inPageRange(page) {\n      return page < 1 || page > this.pages ? false : true;\n    }\n    /**\n     * Checks if there's a next page.\n     * @returns {boolean}\n     */\n\n  }, {\n    key: \"hasNext\",\n    value: function hasNext() {\n      return this.pageEnd + 1 < this.atts.data.length;\n    }\n    /**\n     * Checks if there's a previous page.\n     * @returns {boolean}\n     */\n\n  }, {\n    key: \"hasPrevious\",\n    value: function hasPrevious() {\n      return this.pageStart !== 0;\n    }\n    /**\n     * Advances to the next page.\n     */\n\n  }, {\n    key: \"next\",\n    value: function next() {\n      this.page++;\n    }\n    /**\n     * Goes to the previous page.\n     */\n\n  }, {\n    key: \"previous\",\n    value: function previous() {\n      this.page--;\n    }\n  }, {\n    key: \"offset\",\n    get: function get() {\n      return this.atts.offset;\n    }\n    /**\n     * Sets the paginator offset.\n     * @param {Number} offset\n     */\n    ,\n    set: function set(offset) {\n      this.atts.offset = offset;\n      this.page = 1;\n    }\n  }, {\n    key: \"page\",\n    get: function get() {\n      return this.atts.page;\n    }\n    /**\n     * Sets the current paginator page.\n     */\n    ,\n    set: function set(page) {\n      this.atts.page = this.inPageRange(page) ? page : 1;\n    }\n    /**\n     * Returns the overall number of pages.\n     * @returns {Number}\n     */\n\n  }, {\n    key: \"pages\",\n    get: function get() {\n      return Math.ceil(this.atts.data.length / this.offset);\n    }\n    /**\n     * Returns the page start index.\n     * @returns {Number}\n     * @protected\n     */\n\n  }, {\n    key: \"pageStart\",\n    get: function get() {\n      return this.offset * (this.page - 1);\n    }\n    /**\n     * Returns the page end index.\n     * @returns {Number}\n     * @protected\n     */\n\n  }, {\n    key: \"pageEnd\",\n    get: function get() {\n      var end = this.offset * this.page;\n      var maxLen = this.atts.data.length;\n      return end < maxLen ? end : maxLen;\n    }\n  }]);\n\n  return Paginator;\n}();\n\n\n\n//# sourceURL=webpack://library/./src/index.js?");

/***/ })

/******/ });
});